import { CSSProperties } from 'react';

export const disableStyle = (isSaving: boolean, isEditing: boolean, isDeleting: boolean): CSSProperties => ({
  pointerEvents: isSaving || isEditing || isDeleting ? 'none' : 'auto',
  opacity: isSaving || isEditing || isDeleting ? 0.6 : 1,
});
